/**
 * Identifies one count cell across refreshes. Slot bounds plus status, because slot
 * order can shift between responses and the index cannot be trusted.
 */
export const cellKey = (slot, status) =>
  `${(slot && slot.startTime) || ''}|${(slot && slot.endTime) || ''}|${status}`

/**
 * Which cells hold a different number than they did last refresh.
 *
 * Only meaningful when the query is unchanged - a new date or zone is new context,
 * not movement, and flagging every cell there would be noise. Callers gate on that.
 * Returns an empty map when there is nothing to compare against, so a first load
 * never flashes.
 */
export const diffChangedCells = (prevSlots, nextSlots) => {
  if (!prevSlots || !prevSlots.length || !nextSlots || !nextSlots.length) {
    return {}
  }

  const previous = {}
  prevSlots.forEach((entry) => {
    Object.keys((entry && entry.count) || {}).forEach((status) => {
      previous[cellKey(entry.slot, status)] = Number(entry.count[status]) || 0
    })
  })

  const changed = {}
  nextSlots.forEach((entry) => {
    Object.keys((entry && entry.count) || {}).forEach((status) => {
      const key = cellKey(entry.slot, status)
      const before = previous[key]
      const after = Number(entry.count[status]) || 0

      // A status appearing where the slot previously had none is a change too.
      if (before === undefined ? after > 0 : before !== after) {
        changed[key] = true
      }
    })
  })

  return changed
}

export const hasChangedCells = (...maps) =>
  maps.some((map) => map && Object.keys(map).length > 0)
